import React from 'react';
import {
  ConfigBlock, ExceptionsWrapper,
  TimeItemsWrapper,
  TimesFormWrapper,
} from 'components/molecules/settings/styled';
import {
  Wrapper,
  SelectWrapper,
} from 'components/molecules/settings/TimeConfigs/styled';
import { InputDescription, InputTitle } from '../../../styleds';
import SkeletonLoader from '../../Skeleton';

const SettingsDeliveryLoader = () => {
  return (
    <>
      <div style={{ marginBottom: 40 }}>
        <SkeletonLoader w={'475px'} fullWidth={false} height='44px' />
      </div>
      <TimesFormWrapper>
        <SkeletonLoader fullWidth={false} w={'150px'} height='30px' />
        <div>
          <TimeItemsWrapper>
            {[1, 2, 3].map((i) => (
              <ConfigBlock key={i}>
                <Wrapper>
                  <SkeletonLoader fullWidth={false} w={'100px'} height='30px' />
                  <div style={{ marginTop: 20 }}>
                    <SelectWrapper>
                      <SkeletonLoader fullWidth={true} height='44px' />
                      <div style={{ margin: '0 7px' }}>
                        <SkeletonLoader
                          fullWidth={false}
                          w={'12px'}
                          height='4px'
                        />
                      </div>{' '}
                      <SkeletonLoader fullWidth={true} height='44px' />
                    </SelectWrapper>
                  </div>
                  <div style={{ marginTop: 20 }}>
                    <SkeletonLoader fullWidth={false} w={'120px'} height='30px' />
                  </div>
                </Wrapper>
              </ConfigBlock>
            ))}
          </TimeItemsWrapper>
          <TimeItemsWrapper>
            {[1, 2, 3].map((i) => (
              <ConfigBlock key={i}>
                <Wrapper>
                  <SkeletonLoader fullWidth={false} w={'100px'} height='30px' />
                  <div style={{ marginTop: 20 }}>
                    <SelectWrapper>
                      <SkeletonLoader fullWidth={true} height='44px' />
                      <div style={{ margin: '0 7px' }}>
                        <SkeletonLoader
                          fullWidth={false}
                          w={'12px'}
                          height='4px'
                        />
                      </div>{' '}
                      <SkeletonLoader fullWidth={true} height='44px' />
                    </SelectWrapper>
                  </div>
                  <div style={{ marginTop: 20 }}>
                    <SkeletonLoader fullWidth={false} w={'120px'} height='30px' />
                  </div>
                </Wrapper>
              </ConfigBlock>
            ))}
          </TimeItemsWrapper>
          <TimeItemsWrapper>
            {[1].map((i) => (
              <ConfigBlock key={i}>
                <Wrapper>
                  <SkeletonLoader fullWidth={false} w={'100px'} height='30px' />
                  <div style={{ marginTop: 20 }}>
                    <SelectWrapper>
                      <SkeletonLoader fullWidth={true} height='44px' />
                      <div style={{ margin: '0 7px' }}>
                        <SkeletonLoader
                          fullWidth={false}
                          w={'12px'}
                          height='4px'
                        />
                      </div>{' '}
                      <SkeletonLoader fullWidth={true} height='44px' />
                    </SelectWrapper>
                  </div>
                  <div style={{ marginTop: 20 }}>
                    <SkeletonLoader fullWidth={false} w={'120px'} height='30px' />
                  </div>
                </Wrapper>
              </ConfigBlock>
            ))}
          </TimeItemsWrapper>
        </div>
        <ExceptionsWrapper>
          <InputTitle>
            <SkeletonLoader fullWidth={true} w='200px' height='24px' />
          </InputTitle>
          <InputDescription mt={16}>
            <SkeletonLoader fullWidth={true} w='200px' height='60px' />
          </InputDescription>
          <InputTitle>
            <SkeletonLoader fullWidth={false} w='150px' height='24px' />
          </InputTitle>
        </ExceptionsWrapper>
      </TimesFormWrapper>
    </>
  );
};

export default SettingsDeliveryLoader;
